import { render, staticRenderFns } from "./detail-component-org-and-persons.vue?vue&type=template&id=232990f0&scoped=true"
import script from "./detail-component-org-and-persons.vue?vue&type=script&lang=ts"
export * from "./detail-component-org-and-persons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232990f0",
  null
  
)

export default component.exports